var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import { createModel } from "@byted/hooks";
import { ExperimentStatus } from "../../containers/session-replay-user-research-portal/types";
import useWindowPath from "../useWindowPath";
import { parseJSONWithDefault } from "../../utils";
import { shouldRecordPath } from "../../containers/session-replay-user-research-portal/hooks";
import useGeneralConfigs from "../useGeneralConfigs";
import useSessionReplayCore from "../useSessionReplayCore";
import { saveSessionLink } from "../../containers/session-replay-user-research-portal/components/passive-recorder/service";
import { WINDOW_KEY } from "../../constants";
const useExperiments = (initialState) => {
  var _a, _b, _c;
  const { teaCallbackOn, teaCallbackOff, uid, btm, userCountry, teaSessionId } = useGeneralConfigs();
  const { startBlackboxRecording, dumpBlackboxRecording } = useSessionReplayCore();
  const latestExperimentsRef = React.useRef();
  const callbackRef = React.useRef({});
  const path = useWindowPath();
  const [internalExperiments, setInternalExperiments] = React.useState(
    initialState ? __spreadProps(__spreadValues({}, initialState), {
      // Force disable experiments first. They will be enabled later if the user is eligible.
      allExperiments: (_a = initialState == null ? void 0 : initialState.allExperiments) != null ? _a : [],
      // Find experiments that the user is eligible for
      relevantExperiments: (_c = (_b = initialState == null ? void 0 : initialState.allExperiments) == null ? void 0 : _b.filter(
        (experiment) => {
          var _a2, _b2;
          return ((_a2 = experiment == null ? void 0 : experiment.uids) == null ? void 0 : _a2.includes(uid)) || ((_b2 = experiment == null ? void 0 : experiment.uids) == null ? void 0 : _b2.includes("*"));
        }
      )) != null ? _c : []
    }) : {}
  );
  React.useEffect(() => {
    latestExperimentsRef.current = internalExperiments.relevantExperiments;
  }, [internalExperiments.relevantExperiments]);
  const saveBlackBoxRecording = (experimentId) => __async(void 0, null, function* () {
    var _a2, _b2;
    try {
      const recordingId = yield dumpBlackboxRecording();
      if (recordingId) {
        const saveSessionRes = saveSessionLink(
          {
            sessionId: recordingId,
            userId: uid,
            path: [window.location.pathname],
            countryCode: userCountry != null ? userCountry : "",
            experimentIds: [experimentId.toString()],
            startTime: Date.now() + "",
            teaSessionId: teaSessionId != null ? teaSessionId : (_b2 = (_a2 = window == null ? void 0 : window.Tea) == null ? void 0 : _a2.sessionManager) == null ? void 0 : _b2.getSessionId()
          },
          userCountry != null ? userCountry : "sg"
        );
      }
      return recordingId;
    } catch (e) {
      return void 0;
    }
  });
  const activateExperiment = (experiment) => {
    var _a2, _b2, _c2;
    const activeTeaListener = callbackRef.current[experiment.experimentId];
    if (activeTeaListener) {
      teaCallbackOff ? teaCallbackOff("event", activeTeaListener) : (_a2 = window.Tea) == null ? void 0 : _a2.off("event", activeTeaListener);
      callbackRef.current[experiment.experimentId] = void 0;
    }
    if ((_b2 = latestExperimentsRef == null ? void 0 : latestExperimentsRef.current) == null ? void 0 : _b2.find(
      (exp) => exp.experimentId === experiment.experimentId && exp.experimentStatus === ExperimentStatus.ACTIVE
    )) {
      return;
    }
    const updatedRelevantExperiments = (_c2 = internalExperiments == null ? void 0 : internalExperiments.relevantExperiments) == null ? void 0 : _c2.map((relevantExperiment) => {
      if (relevantExperiment.experimentId === experiment.experimentId) {
        relevantExperiment.experimentStatus = ExperimentStatus.ACTIVE;
      }
      return relevantExperiment;
    });
    setInternalExperiments((prev) => __spreadProps(__spreadValues({}, prev), {
      relevantExperiments: updatedRelevantExperiments
    }));
  };
  const deactivateExperiment = (deactivatedIds) => {
    var _a2;
    const updatedRelevantExperiments = (_a2 = internalExperiments == null ? void 0 : internalExperiments.relevantExperiments) == null ? void 0 : _a2.map((relevantExperiment) => {
      var _a3;
      if (deactivatedIds.includes((_a3 = relevantExperiment.experimentId) == null ? void 0 : _a3.toString())) {
        relevantExperiment.experimentStatus = ExperimentStatus.INACTIVE;
      }
      return relevantExperiment;
    });
    setInternalExperiments((prev) => __spreadProps(__spreadValues({}, prev), {
      relevantExperiments: updatedRelevantExperiments
    }));
  };
  const setActiveExperiments = (experiments) => {
    setInternalExperiments((prev) => __spreadProps(__spreadValues({}, prev), {
      activeExperiments: experiments
    }));
  };
  const updateExperimentsOnPathChange = React.useCallback(
    (relevantExperiments) => {
      var _a2;
      const pathBPoint = (_a2 = btm == null ? void 0 : btm.getCurrentPageBId(path)) != null ? _a2 : path;
      const updatedRelevantExperiments = relevantExperiments.map((experiment) => {
        var _a3, _b2, _c2;
        const experimentHasTriggers = experiment.recordingStartBtmPoints || experiment.journeyEntryPage || experiment.blackBoxTriggers;
        switch (experiment == null ? void 0 : experiment.experimentStatus) {
          case ExperimentStatus.ACTIVE: {
            if (!shouldRecordPath(pathBPoint, [experiment])) {
              experiment.experimentStatus = ExperimentStatus.INACTIVE;
            }
            return experiment;
          }
          case ExperimentStatus.LISTENING: {
            if (!shouldRecordPath(pathBPoint, [experiment])) {
              experiment.experimentStatus = ExperimentStatus.INACTIVE;
              const activeTeaListener = callbackRef.current[experiment.experimentId];
              if (activeTeaListener) {
                teaCallbackOff ? teaCallbackOff("event", activeTeaListener) : (_a3 = window.Tea) == null ? void 0 : _a3.off("event", activeTeaListener);
                callbackRef.current[experiment.experimentId] = void 0;
              }
            }
            return experiment;
          }
          default: {
            if (experimentHasTriggers) {
              if (shouldRecordPath(pathBPoint, [experiment])) {
                experiment.experimentStatus = ExperimentStatus.LISTENING;
                const teaCallback = (e) => {
                  var _a4, _b3, _c3, _d, _e, _f, _g;
                  const teaEvent = e == null ? void 0 : e[0];
                  if ((teaEvent == null ? void 0 : teaEvent.event).includes("btm")) {
                    const btmEvent = ((_a4 = teaEvent == null ? void 0 : teaEvent.params) == null ? void 0 : _a4.btm) ? (_b3 = teaEvent == null ? void 0 : teaEvent.params) == null ? void 0 : _b3.btm : (_c3 = parseJSONWithDefault(teaEvent == null ? void 0 : teaEvent.params, { btm: "" })) == null ? void 0 : _c3.btm;
                    if ((_d = experiment.recordingStartBtmPoints) == null ? void 0 : _d.includes(btmEvent)) {
                      activateExperiment(experiment);
                    }
                    if ((_e = experiment.journeyEntryPage) == null ? void 0 : _e.includes(btmEvent)) {
                      activateExperiment(experiment);
                    }
                    if ((_f = experiment.blackBoxTriggers) == null ? void 0 : _f.includes(btmEvent)) {
                      saveBlackBoxRecording((_g = experiment.experimentId) == null ? void 0 : _g.toString());
                    }
                  }
                };
                callbackRef.current[experiment.experimentId] = teaCallback;
                teaCallbackOn ? teaCallbackOn == null ? void 0 : teaCallbackOn("event", teaCallback) : (_c2 = (_b2 = window == null ? void 0 : window.Tea) == null ? void 0 : _b2.on) == null ? void 0 : _c2.call(_b2, "event", teaCallback);
              }
            }
            if (!experimentHasTriggers) {
              if (shouldRecordPath(pathBPoint, [experiment])) {
                experiment.experimentStatus = ExperimentStatus.ACTIVE;
              }
            }
            return experiment;
          }
        }
      });
      setInternalExperiments((prev) => __spreadProps(__spreadValues({}, prev), {
        relevantExperiments: updatedRelevantExperiments
      }));
    },
    [teaCallbackOn, btm, path]
  );
  React.useEffect(() => {
    var _a2;
    console.log("[SR] Hooks", callbackRef == null ? void 0 : callbackRef.current);
    updateExperimentsOnPathChange((_a2 = internalExperiments.relevantExperiments) != null ? _a2 : []);
  }, [path, btm, initialState == null ? void 0 : initialState.relevantExperiments, uid]);
  React.useEffect(() => {
    if (initialState == null ? void 0 : initialState.enableSessionReplay) {
      startBlackboxRecording();
      window[WINDOW_KEY.SAVE_BLACKBOX_RECORDING] = saveBlackBoxRecording;
    }
  }, []);
  const activeExperiments = React.useMemo(
    () => {
      var _a2;
      return (_a2 = internalExperiments.relevantExperiments) == null ? void 0 : _a2.filter(
        (experiment) => experiment.experimentStatus === ExperimentStatus.ACTIVE
      );
    },
    [internalExperiments.relevantExperiments]
  );
  const inactiveExperiments = React.useMemo(
    () => {
      var _a2;
      return (_a2 = internalExperiments.relevantExperiments) == null ? void 0 : _a2.filter(
        (experiment) => experiment.experimentStatus === ExperimentStatus.INACTIVE
      );
    },
    [internalExperiments.relevantExperiments]
  );
  const listeningExperiments = React.useMemo(
    () => {
      var _a2;
      return (_a2 = internalExperiments.relevantExperiments) == null ? void 0 : _a2.filter(
        (experiment) => experiment.experimentStatus === ExperimentStatus.LISTENING
      );
    },
    [internalExperiments.relevantExperiments]
  );
  window[WINDOW_KEY.EXPERIMENTS] = {
    activeExperiments,
    inactiveExperiments,
    listeningExperiments,
    internalExperiments
  };
  return {
    internalExperiments,
    setInternalExperiments,
    activateExperiment,
    deactivateExperiment,
    setActiveExperiments,
    activeExperiments,
    inactiveExperiments,
    listeningExperiments
  };
};
const SessionReplayExperimentModel = createModel(useExperiments);
var useExperiments_default = SessionReplayExperimentModel.useContext;
export {
  SessionReplayExperimentModel,
  useExperiments_default as default,
  useExperiments
};
